import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
    selector: 'app-how-to-apply',
    templateUrl: './how-to-apply.component.html',
    styleUrls: ['./how-to-apply.component.scss']
})
export class HowToApplyComponent implements OnInit {
    activeIndex: number | null = null;
    activeStep = 0;
    currentPath: string;

    constructor(private router: Router,
        private location: Location) {
        this.currentPath = this.location.path();
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

    ngOnInit(): void {
    }

    toggleAccordion(index: number) {
        this.activeIndex = this.activeIndex === index ? null : index;
    }

    steps = [
        {
            title: 'Step 1', content: `
<p class="font-semibold">Registration:</p>
  <ul class="list-disc pl-5 mt-2 space-y-2">
    <li>Visit www.arni.in</li>
    <li>Register yourself</li>
    <li>Create login credentials</li>
  </ul>
`
        },
        {
            title: 'Step 2',
            content: `
  <p class="font-semibold">Admission Process Begins</p>
  <ul class="list-disc pl-5 mt-2 space-y-1">
    <li>Log in to your account</li>
    <li>Choose your desired course</li>
    <li>Check eligibility</li>
  </ul>`
        },
        {
            title: 'Step 3',
            content: '<p class=" font-semibold">Application Submission</p> <ul class="list-disc pl-5 mt-2 space-y-1"><li>Fill in the required details</li>   <li>Submit documents</li>    <li>Pay the admission fee online</li> </ul>'
        },
        {
            title: 'Step 4',
            content: `
  <p class="font-semibold">Submission Evaluation</p>
  <ul class="list-disc pl-6 space-y-1 mb-4">
    <li>ARNI University will verify the submitted details.</li>
    <li>The application will be either accepted or rejected</li>
  </ul>
  <p class="mb-2">(If accepted, the Student will receive a student ID and study material assistance with the class schedule.)</p>
  <p class="mb-2">(If rejected, you will assist with the issue to re-initiate the process.)</p>`
        },
        {
            title: 'Step 5',
            content: '<p class="font-semibold">Apply for Scholarships</p>  <ul class="list-disc pl-5 mt-2 space-y-1"><li>Apply for the Flat Admission Scholarship</li> <li>If approved, receive a Provisional Admission Offer</li></ul>'
        }
    ];

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

}
